import { supabase } from '../lib/supabase';

/**
 * Save a click event to public.link_clicks before redirecting.
 * No auth required — table has a public INSERT policy.
 */
export const saveClick = async ({
  campaignId,
  influencerId,
  slug,
  platform,
  destinationUrl,
}) => {
  const userAgent = navigator?.userAgent || '';
  const device = detectDeviceType(userAgent);

  // Attempt country detection with a 3-second timeout
  let country = 'unknown';
  try {
    const res = await fetch('https://ipapi.co/json/', {
      signal: AbortSignal.timeout(3000),
    });
    if (res?.ok) {
      const json = await res?.json();
      country = json?.country_code || json?.country || 'unknown';
    }
  } catch {
    // Geo lookup failed — proceed without country
  }

  try {
    const { error } = await supabase?.from('link_clicks')?.insert({
      campaign_id: campaignId || null,
      influencer_id: influencerId || null,
      slug: slug || '',
      platform: platform || '',
      destination_url: destinationUrl || '',
      user_agent: userAgent,
      country,
      device,
      clicked_at: new Date()?.toISOString(),
    });

    if (error) {
      console.error('Click tracking insert error:', error?.message);
    }
    return { error: error || null };
  } catch (err) {
    console.error('Click tracking failed:', err?.message);
    return { error: err };
  }
};

/**
 * Detect device type from user agent string.
 */
export const detectDeviceType = (ua = '') => {
  if (/mobile/i?.test(ua)) return 'mobile';
  if (/tablet|ipad/i?.test(ua)) return 'tablet';
  return 'desktop';
};

/**
 * Fetch click analytics for a given set of slugs (or all if no slugs provided).
 * Returns total clicks and per-platform breakdown.
 */
export const getClickSummary = async (slugs = []) => {
  try {
    let query = supabase
      ?.from('link_clicks')
      ?.select('id, platform, slug, campaign_id, influencer_id, country, device, clicked_at');

    if (slugs?.length > 0) {
      query = query?.in('slug', slugs);
    }

    const { data, error } = await query?.order('clicked_at', { ascending: false });

    if (error) throw error;

    const clicks = data || [];

    const platformBreakdown = {
      spotify: 0,
      apple_music: 0,
      youtube_music: 0,
      tiktok_sound: 0,
    };

    clicks?.forEach((click) => {
      if (platformBreakdown?.hasOwnProperty(click?.platform)) {
        platformBreakdown[click?.platform] += 1;
      }
    });

    return {
      data: {
        totalClicks: clicks?.length,
        platformBreakdown,
        clicks,
      },
      error: null,
    };
  } catch (err) {
    console.error('Error fetching click summary:', err?.message);
    return { data: null, error: err };
  }
};
